// @flow

import React from 'react';
import styled from 'styled-components';
import { debounce } from 'lodash';

const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 15px;
`;

const Input = styled.input.attrs({
  maxLength: props => props.maxLength,
  style: ({ fontSize }) => ({
    fontSize: fontSize
  })
})`
  display: block;
  height: 35px;
  width: 100%;
  border-radius: 2px;
  background-color: #ffffff;
  padding: 0 0 0 15px;
  border: 1px solid #ececec;
  line-height: 35px;
  font-size: 16px;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 2px;
  &::placeholder {
    font-weight: 500;
    color: #9b9b9b;
  }
  &:disabled {
    background: #ececec;
    color: #9b9b9b;
  }
  ${props => props.hasError && 'border-color: #dc3545;'}
`;

const ErrorMessage = styled.span.attrs({
  className: 'error-message'
})`
  color: #ff1400;
  top: 35px;
  font-size: 14px;
  line-height: 17px;
  margin-top: 0px;
  position: initial;
`;

type PropsType = {
  name: string,
  value: string,
  type: string,
  placeholder: string,
  onValueChange: (value: string, input: string) => void,
  searchNeigborhood: (value: string) => void,
  fontSize?: number,
  schema?: any,
  children?: any,
  maxLength?: number,
  disabled?: boolean
};

type StateType = {
  error: string,
  touched: boolean,
  inputValue: string
};

export default class InputZipComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    fontSize: 16,
    disabled: false
  };

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      touched: false,
      inputValue: this.props.value
    };
    this.sendRequest = debounce(this.sendRequest, 800);
  }

  handleChange = ({ target }: Event<HTMLInputElement>): void => {
    const inputValue = target.value;
    this.setState({ inputValue });
    this.validationSchema(inputValue, false, false);
  };

  handleBlur = () => {
    this.validationSchema(this.state.inputValue, true, !this.state.error);
    if (!this.state.touched) this.setState({ touched: true });
  };

  validationSchema = (
    inputValue: string,
    onBlur: boolean,
    error: boolean
  ): void => {
    const { name } = this.props;
    if (this.props.schema) {
      this.props.schema
        .validate({ inputValue })
        .then(() => {
          this.setState({ error: '' });
        })
        .catch(e => {
          this.setState({ error: e.message });
        });
    }
    if (onBlur && error) this.props.onValueChange(inputValue, name);
    if (inputValue && inputValue.length >= 4 && !error && !onBlur) {
      this.sendRequest(inputValue);
    }
  };

  sendRequest = value => this.props.searchNeigborhood(value);

  render() {
    const { error, touched, inputValue } = this.state;
    const { placeholder, fontSize, type, maxLength, disabled } = this.props;
    return (
      <StyledValidatedInput>
        <Input
          fontSize={fontSize}
          value={inputValue}
          type={type}
          placeholder={placeholder}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          maxLength={maxLength}
          hasError={error && touched}
          disabled={disabled}
        />
        {this.props.children}
        {error && touched && <ErrorMessage>{error}</ErrorMessage>}
      </StyledValidatedInput>
    );
  }
}
